export default {
  login: "សូមចូលដើម្បីបន្ត...",
  password_rule: "* លេខសម្ងាត់មានការបំបែកអក្សរធំតូច និងត្រូវមានពី 6 ដល់ 10 តួអក្សរ។",
  nickname_rule: "* អ្នកអាចកំណត់ឈ្មោះក្រៅសម្រាប់បង្ហាញ និងចូល (6 ដល់ 15 តួអក្សរឬលេខ)។ សូមចំណាំថា អ្នកអាចកំណត់បានតែម្ដងតែប៉ុណ្ណោះ។ មិនអាចកែប្រែ ឬលុបចោលបាននោះទេ។",
  change_password_succeed: "ប្តូរលេខសម្ងាត់បានជោគជ័យ។",
  add_secondary_succeed: "កំណត់ឈ្មោះក្រៅបានជោគជ័យ។",
  succeed: "អ្នកបានបញ្ចប់សកម្មភាពដោយជោគជ័យ!",
  failed: "អ្នកបានបរាជ័យក្នុងការបញ្ចប់សកម្មភាព!",
  no_information_available: "គ្មានព័ត៌មាន។",
  select_display_language: "ជ្រើសរើសភាសាដែលអ្នកចូលចិត្ត។",
  select_odds_type: "ជ្រើសរើសបែបបទអាប់សម្រាប់បង្ហាញ។",
  select_page_type: "ជ្រើសរើសប្រភេទទំព័រដែលអ្នកចូលចិត្ត សម្រាប់ទំព័រប្រកួតថ្ងៃនេះ និងទីផ្សារដើម។",
  select_show_score_map: "អនុញ្ញាតឲ្យប្រព័ន្ធបង្ហាញផែនទីពិន្ទុស្វ័យប្រវត្តិខណៈពេលភ្នាល់។",
  select_default_event_sorting: "ជ្រើសរើសលំដាប់ព្រឹត្តិការណ៍ដែលអ្នកចូលចិត្ត។",
  select_market_type: "ជ្រើសរើសទីផ្សារដែលអ្នកចូលចិត្ត។",
  select_page_size: "ជ្រើសរើសទំហំទំព័រដែលអ្នកចូលចិត្ត។",
  change_sports_menu_order: "សូមអូសកីឡាដើម្បីប្តូរលំដាប់បញ្ជីកីឡា។",
  view_outstanding_bets_in_bet_list: "ភ្នាល់កំពុងដំណើរការអាចចំណាយពេល។ សូមចូលទៅក្នុងបញ្ជីភ្នាល់ដើម្បីមើល។",
  time_display_in_gmt_plus_8: "ម៉ោងខាងលើបង្ហាញជា GMT+8។",
  select_default_stake: "អនុញ្ញាតឲ្យប្រព័ន្ធបញ្ចូលចំនួនភ្នាល់ស្វ័យប្រវត្តិ។",
  bet_empty: "សន្លឹកភ្នាល់របស់អ្នកទទេ។ សូមចុចលើអាប់ដើម្បីជ្រើសរើស។",
  no_event: "ពេលនេះគ្មានការប្រកួត ឬហ្គេម។ សូមមកមើលម្តងទៀត។",
  no_bets: "គ្មានភ្នាល់កំពុងដំណើរការ",
  no_waiting: "គ្មានការភ្នាល់រងចាំ",
  no_void: "គ្មានការភ្នាល់ដែលបានលុបចោល",
  confirmation: "តើអ្នកប្រាកដថាចង់ភ្នាល់នេះទេ?",
  olderversion: "បានរកឃើញកំណែចាស់។ ចុច OK ដើម្បីធ្វើបច្ចុប្បន្នភាព ឬចុច Ctrl-F5។",
  gmt8: "ម៉ោងខាងលើបង្ហាញជា GMT+8។",
  confirm_bet: "បញ្ជាក់ការភ្នាល់?",
  match_not_started: "ការប្រកួតមិនទាន់ចាប់ផ្តើម",
  odds_changed: "អាប់បានផ្លាស់ប្តូរ",
  ldiff_changed: "ភាគរយបានផ្លាស់ប្តូរ",
  to: "ដល់",
  dnsta: "កុំបង្ហាញម្តងទៀត។",
  login2: "ដើម្បីចូល និងចូលលេងហ្គេម សូមចុះឈ្មោះជាមុន។ ប្រសិនបើមានគណនីរួចហើយ សូមចូល។",
  no_video: "រកមិនឃើញវីដេអូក្នុង %%",
  days: "ថ្ងៃ",
  hours: "ម៉ោង",
  mins: "នាទី",
  secs: "វិនាទី",
  room_full: "បន្ទប់នេះពេញហើយ",
  room_joined: "អ្នកបានចូលបន្ទប់នេះរួចហើយ",
  no_room: "គ្មានបន្ទប់។ សូមជ្រើសរើសជម្រើសផ្សេង ឬព្យាយាមម្ដងទៀត។",
  are_you_sure: "តើអ្នកប្រាកដថាចង់បន្តទេ?",
  no_matches: "ពេលនេះគ្មានការប្រកួត ឬហ្គេម។",
  pin_code: "ឧ. 123456",
  accept_terms: "ដោយសូមសម្គាល់ថា អ្នកបានអាន ដឹង និងយល់ព្រមនឹងលក្ខខណ្ឌខាងលើ។",
  accept_required: "សូមអាន ដឹង និងយល់ព្រមនឹង<br />លក្ខខណ្ឌខាងលើ មុនពេលបន្ត។",
  my_room: "បន្ទប់របស់ខ្ញុំ",
  not_winning_prize_in_this_tournament: "មិនឈ្នះរង្វាន់នៅក្នុងការប្រកួតនេះ",
  you_did_not_join_this_room: "អ្នកមិនបានចូលបន្ទប់នេះទេ",
  room_password_rule: "* PIN ត្រូវមាន 6 លេខ។",
  jan: "មករា",
  feb: "កុម្ភៈ",
  mar: "មីនា",
  apr: "មេសា",
  may: "ឧសភា",
  jun: "មិថុនា",
  jul: "កក្កដា",
  aug: "សីហា",
  sep: "កញ្ញា",
  oct: "តុលា",
  nov: "វិច្ឆិកា",
  dec: "ធ្នូ",
  must_accept_better_odds: "លំនាំដើម ប្រព័ន្ធនឹងទទួលយកអាប់ល្អជាង។ សូមយោងលក្ខខណ្ឌបន្ថែម។",
  maintenance_notice: "ប្រព័ន្ធកំពុងធ្វើការថែទាំ។ សូមមកវិញពេលក្រោយ។",
  deduct_confirm: "នេះនឹងចាប់ផ្តើមហ្គេម ហើយឥណទានរបស់អ្នកនឹងត្រូវកាត់។<br />តើអ្នកប្រាកដទេ?",
  no_more_bets: "មិនអាចភ្នាល់បន្ថែម។",
  over_max_match: "ការប្រកួតលើសចំនួនអតិបរមាដែលអាចជ្រើសបាន។<br />សូមពង្រីកបញ្ជីហើយជ្រើសការប្រកួត។",
  button_skip: "រំលង",
  button_previous: "ថយក្រោយ",
  button_next: "បន្ទាប់",
  button_stop: "បញ្ចប់",
  button_continue: "បន្ត",
  tour_content_1: "<h6>ស្វាគមន៍មកកាន់ការប្រកួត WBET</h6><p>យើងមានក្តីរីករាយប្រកាសការប្រកួតថ្មីសម្រាប់អ្នកគាំទ្រផ្លូវការរបស់គេហទំព័រ។</p>",
  tour_content_2: "<h6>បន្ទប់សាធារណៈ</h6><p>សមាជិកប្រកួតគ្នាជាផ្លូវការដោយសំបុត្រចូលលេង។</p>",
  tour_content_3: "<h6>បន្ទប់ឯកជន</h6><p>សមាជិកអាចបើកបន្ទប់ជាមួយមិត្តភក្តិដោយប្រើ PIN ចូល។</p>",
  tour_content_4: "<h6>បន្ទប់សាធារណៈឥតគិតថ្លៃ</h6><p>រៀបចំដោយស្ថាប័ននៅព្រឹត្តិការណ៍ពិសេសសម្រាប់សមាជិក។</p>",
  tour_content_5: "<h6>ចំនួនអ្នកលេង និងថ្លៃចូល</h6><p>អ្នកលេង៖ ចំនួនអតិបរមា។</p><p>ថ្លៃចូល៖ អាស្រ័យលើបន្ទប់ (រូបិយប័ណ្ណគណនី)។</p>",
  tour_content_6: "<h6>ព័ត៌មានបន្ទប់</h6><p>ចុចដើម្បីមើលស្ថិតិ និងចូលរួម។</p>",
  tour_content_7: "<h6>ព័ត៌មានរង្វាន់</h6><p>សរុបរង្វាន់សម្រាប់អ្នកឈ្នះ និងលេខសម្គាល់បន្ទប់។</p>",
  tour_content_8: "<h6>ព័ត៌មានការចាប់ផ្តើមបន្ទប់</h6><p>ស្ថានភាពបន្ទប់ និងពេលចុងក្រោយចូលរួម។</p>",
  tour_content_9: "<h6>បង្កើតបន្ទប់ឯកជន</h6><p>បង្កើតបន្ទប់ និងអញ្ជើញមិត្តភក្តិដោយ PIN ចូល។</p>",
  tour_content_10: "<h6>ការរៀបចំពិន្ទុ</h6><p>បង្ហាញពិន្ទុសម្រាប់ការតាមដានលទ្ធផល។</p>",
  banner1_h1: "ភ្នាល់កីឡា",
  banner1_p: "ជាមួយជម្រើសលើសពី 90 ប្រភេទ និងព្រឹត្តិការណ៍បន្តផ្ទាល់ពេញគ្រប់ថ្ងៃ អារម្មណ៍រំភើបគ្មានដាច់។",
  banner2_h1: "កាស៊ីណូបន្តផ្ទាល់",
  banner2_p: "ឈ្នះពេញចិត្ត បំពង់ជាមួយបទពិសោធន៍កាស៊ីណូដ៏ប្រណិត។",
  banner3_h1: "ហ្គេមស្លុត",
  banner3_p: "ជម្រើសហ្គេមដ៏ទូលំទូលាយ។ សាកល្បងដោយខ្លួនឯងឥឡូវនេះ។",
  banner4_h1: "ការប្រយុទ្ធអេឡិចត្រូនិច",
  banner4_p: "ប្រមូលតួអង្គដែលអ្នកចូលចិត្ត បោះជើងក្នុងប្រកួត និងស្រួលចិត្តក្នុងការប្រយុទ្ធ!",
  banner5_h1: "ការប្រកួត",
  banner5_p: "រួចរាល់សម្រាប់ការប្រកួតជ័យលាភី ដោយក្រុមទាំងអស់ចូលរួមក្នុងព្រឹត្តិការណ៍បាល់ទាត់ប្រចាំឆ្នាំ។",
};
